<!-- standard-review.html -->
<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
  <p class="text-load">&nbsp;&nbsp; Loading...</p>
</div>
<div [class.blur]="isLoading">

  <!-- ─── Breadcrumb Bar ─── -->
  <div class="breadcrumb-bar">
    <div class="breadcrumb">
      <a class="breadcrumb-link" [routerLink]="['/planning']">Planning</a>
      <span class="breadcrumb-sep" aria-hidden="true"></span>
      <span class="breadcrumb-current">Add {{ reviewTypeLabel }}</span>
    </div>
  </div>

  <!-- ─── Main Content ─── -->
  <main class="main-content">

    <!-- Page title -->
    <div class="page-title-bar">
      <h2 class="page-title">{{ useGoLiveLayout ? 'Add Annual Review Item ' + reviewTypeLabel : 'Add ' + reviewTypeLabel }}</h2>
    </div>
    <div class="below-main">
      <!-- Form card -->
      <div class="form-card">

        <!-- Row 1 -->
        <div class="form-row">

          <!-- Review Name (auto-generated) -->
          <div class="form-field" data-field="ReviewName">
            <label class="field-label">
              Review Name
              <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">Name of Review : Financial Year + Type Of Review Code + Master Client Name +
                  Project Name + Location</span>
              </span>
            </label>
            <textarea #reviewNameTextarea class="field-input field-input--disabled field-input--review-name"
              [value]="form.ReviewName" placeholder="Review Name" readonly tabindex="-1" rows="1"></textarea>
            @if (reviewNameDuplicateError) {
            <span class="field-error">{{ reviewNameDuplicateError }}</span>
            }
          </div>

          <!-- Proposed Year -->
          <div class="form-field" data-field="ProposedYear">
            <label class="field-label">
              Proposed Year
              <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">Here add the tooltip or notes that will help the form</span>
              </span>
            </label>
            <div class="select-wrapper">
              <select class="field-select" [(ngModel)]="form.ProposedYear" (ngModelChange)="onProposedYearChange()">
                <option value="" disabled>Select Year</option>
                @for (year of proposedYears; track year.ProposedYearId) {
                <option [value]="year.ProposedYear">{{ year.DisplayName }}</option>
                }
              </select>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
            @if (formErrors['ProposedYear']) {
            <span class="field-error">{{ formErrors['ProposedYear'] }}</span>
            }
          </div>

          <!-- Master Client Name -->
          <div class="form-field" data-field="MasterClientName">
            <label class="field-label">
              <span class="label-left">
                Master Client Name
                <span class="required">*</span>
                <span class="info-tooltip-wrapper">
                  <span class="info-icon">i</span>
                  <span class="info-tooltip">Here add the tooltip or notes that will help the form</span>
                </span>
              </span>
              <a class="label-link" (click)="openGuidelineLink()"
                matTooltip="If the Client or Project you are looking for is not available in the dropdown, it must first be created in RepLetter. Please send a request to the RepLetter Admin to add it. Click here to view the SharePoint guide for detailed steps."
                matTooltipPosition="above">Guideline</a>
            </label>
            <div class="searchable-select client-select">
              <div class="searchable-select__display field-select" (click)="toggleClientDropdown()"
                [class.placeholder]="!form.MasterClientName">
                {{ form.MasterClientName || 'Select Master Client' }}
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (clientDropdownOpen) {
              <div class="searchable-dropdown">
                <input type="text" class="searchable-dropdown__search" #clientSearchInput [(ngModel)]="clientSearchTerm"
                  placeholder="Search..." />
                <ul class="searchable-dropdown__list">
                  @for (name of filteredClientNames; track name) {
                  <li (mousedown)="selectClient(name)">{{ name }}</li>
                  }
                  @if (filteredClientNames.length === 0) {
                  <li class="no-results">No matches</li>
                  }
                </ul>
              </div>
              }
            </div>
            @if (formErrors['MasterClientName']) {
            <span class="field-error">{{ formErrors['MasterClientName'] }}</span>
            }
          </div>

        </div>

        <!-- Row 2 -->
        <div class="form-row">

          <!-- D&T Project Name -->
          <div class="form-field" data-field="D&amp;TProjectName">
            <label class="field-label">
              <span class="label-left">
                D&amp;T Project Name
                <span class="required">*</span>
                <span class="info-tooltip-wrapper">
                  <span class="info-icon">i</span>
                  <span class="info-tooltip">Here add the tooltip or notes that will help the form</span>
                </span>
              </span>
              <a class="label-link" (click)="openGuidelineLink()"
                matTooltip="If the Client or Project you are looking for is not available in the dropdown, it must first be created in RepLetter. Please send a request to the RepLetter Admin to add it. Click here to view the SharePoint guide for detailed steps."
                matTooltipPosition="above">Guideline</a>
            </label>
            <div class="searchable-select project-select">
              <div class="searchable-select__display field-select" (click)="toggleProjectDropdown()"
                [class.placeholder]="!form['D&TProjectName']">
                {{ form['D&TProjectName'] || 'Select Project' }}
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (projectDropdownOpen) {
              <div class="searchable-dropdown">
                <input type="text" class="searchable-dropdown__search" #projectSearchInput
                  [(ngModel)]="projectSearchTerm" placeholder="Search..." />
                <ul class="searchable-dropdown__list">
                  @for (name of filteredProjectNames; track name) {
                  <li (mousedown)="selectProject(name)">{{ name }}</li>
                  }
                  @if (filteredProjectNames.length === 0) {
                  <li class="no-results">No matches</li>
                  }
                </ul>
              </div>
              }
            </div>
            @if (formErrors['D&TProjectName']) {
            <span class="field-error">{{ formErrors['D&TProjectName'] }}</span>
            }
          </div>

          <!-- Contract Number -->
          <div class="form-field" data-field="ContractNumber">
            <label class="field-label">
              Contract Number
              <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">Here add the tooltip or notes that will help the form</span>
              </span>
            </label>
            <div class="searchable-select contract-select">
              <div class="searchable-select__display field-select" (click)="toggleContractDropdown()"
                [class.placeholder]="!form.ContractNumber">
                {{ form.ContractNumber || 'Select' }}
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (contractDropdownOpen) {
              <div class="searchable-dropdown">
                <input type="text" class="searchable-dropdown__search" #contractSearchInput
                  [(ngModel)]="contractSearchTerm" placeholder="Search..." />
                <ul class="searchable-dropdown__list">
                  @for (num of filteredContractNumbers; track num) {
                  <li (mousedown)="selectContract(num)">{{ num }}</li>
                  }
                  @if (filteredContractNumbers.length === 0) {
                  <li class="no-results">No matches</li>
                  }
                </ul>
              </div>
              }
            </div>
            @if (formErrors['ContractNumber']) {
            <span class="field-error">{{ formErrors['ContractNumber'] }}</span>
            }
          </div>

          <!-- Additional Contract Number -->
          <div class="form-field">
            <label class="field-label">Additional Contract Number</label>
            <input type="text" class="field-input" [(ngModel)]="form.AdditionalContractNumber"
              (input)="onAdditionalContractNumberInput($event)" (keypress)="onAdditionalContractNumberKeyPress($event)"
              inputmode="numeric" maxlength="10" placeholder="Enter Additional Contract Number" />
            @if (formErrors['AdditionalContractNumber']) {
            <span class="field-error">{{ formErrors['AdditionalContractNumber'] }}</span>
            }
          </div>

        </div>

        <!-- Row 3 -->
        <div class="form-row">

          <!-- Market -->
          <div class="form-field" data-field="Market">
            <label class="field-label">
              Market
              <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">Auto-filled from the selected Contract Number</span>
              </span>
            </label>
            <input type="text" class="field-input field-input--disabled" [value]="form.Market" placeholder="Market"
              readonly tabindex="-1" />
            @if (formErrors['Market']) {
            <span class="field-error">{{ formErrors['Market'] }}</span>
            }
          </div>

          <!-- Market Unit -->
          <div class="form-field" data-field="MarketUnit">
            <label class="field-label">
              Market Unit <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">Auto-filled from the selected Contract Number</span>
              </span>
            </label>
            <input type="text" class="field-input field-input--disabled" [value]="form.MarketUnit"
              placeholder="Market Unit" readonly tabindex="-1" />
            @if (formErrors['MarketUnit']) {
            <span class="field-error">{{ formErrors['MarketUnit'] }}</span>
            }
          </div>

          @if (!useGoLiveLayout) {
          <!-- Customer Relationship Name -->
          <div class="form-field">
            <label class="field-label">Customer Relationship Name</label>
            <input type="text" class="field-input" [(ngModel)]="form.CustomerRelationshipName"
              placeholder="Enter Customer Relationship Name" />
          </div>
          }

        </div>

        @if (isOnDemand || isSpecialProject) {
        <!-- ── ODR / SPR shared fieldwork date section ── -->
        <div class="border-top"></div>
        <div class="form-row">
          <div class="form-field">
            <label class="field-label">Fieldwork Start Date</label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!onDemandFormErrors['FwStartDate']" (click)="openDatePicker(onDemandFwStartInput)">
              <span class="gl-date-display">{{ formatDateDisplay(onDemandFwStartDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #onDemandFwStartInput class="gl-date-hidden" [(ngModel)]="onDemandFwStartDate"
                (ngModelChange)="onDemandFwStartDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (onDemandFormErrors['FwStartDate']) {
            <span class="field-error">{{ onDemandFormErrors['FwStartDate'] }}</span>
            }
          </div>

          <div class="form-field">
            <label class="field-label">Fieldwork End Date</label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!onDemandFormErrors['FwEndDate']" (click)="openDatePicker(onDemandFwEndInput)">
              <span class="gl-date-display">{{ formatDateDisplay(onDemandFwEndDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #onDemandFwEndInput class="gl-date-hidden" [(ngModel)]="onDemandFwEndDate"
                (ngModelChange)="onDemandFwEndDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (onDemandFormErrors['FwEndDate']) {
            <span class="field-error">{{ onDemandFormErrors['FwEndDate'] }}</span>
            }
          </div>

          <div class="form-field">
            @if (isSpecialProject) {
            <label class="field-label">
              Type of Project <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">If your project is not listed here, please contact the Admin.</span>
              </span>
            </label>
            <div class="searchable-select type-of-project-select">
              <div class="searchable-select__display field-select" (click)="toggleTypeOfProjectDropdown()"
                [class.placeholder]="!specialProjectTypeOfProject"
                [class.field-select--error]="!!specialProjectFormErrors['TypeOfProject']">
                {{ specialProjectTypeOfProject || 'Select Type of Project' }}
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (typeOfProjectDropdownOpen) {
              <div class="searchable-dropdown">
                <input type="text" class="searchable-dropdown__search" #typeOfProjectSearchInput
                  [(ngModel)]="typeOfProjectSearchTerm" placeholder="Search..." />
                <ul class="searchable-dropdown__list">
                  @for (opt of filteredTypeOfProjectOptions; track opt) {
                  <li (mousedown)="selectTypeOfProject(opt)">{{ opt }}</li>
                  }
                  @if (filteredTypeOfProjectOptions.length === 0) {
                  <li class="no-results">No matches</li>
                  }
                </ul>
              </div>
              }
            </div>
            @if (specialProjectFormErrors['TypeOfProject']) {
            <span class="field-error">{{ specialProjectFormErrors['TypeOfProject'] }}</span>
            }
            }
          </div>
        </div>
        }

        @if (isGoLive) {
        <!-- ── Go-Live specific section ── -->
        <div class="border-top"></div>

        <!-- Type of Review + Go-Live Date -->
        <div class="form-row form-row--top">
          <div class="form-field">
            <label class="field-label">
              Type of Review
              <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">Select whether this covers Pre and Post Go-Live or only Post Go-Live</span>
              </span>
            </label>
            <div class="gl-radio-group">
              <label class="gl-radio-option">
                <input type="radio" name="glTypeOfReview" value="pre-post" [(ngModel)]="glTypeOfReview"
                  (ngModelChange)="onTypeOfReviewChange()" />
                <span class="gl-radio-custom"></span>
                Pre and Post Go-Live
              </label>
              <label class="gl-radio-option">
                <input type="radio" name="glTypeOfReview" value="post-only" [(ngModel)]="glTypeOfReview"
                  (ngModelChange)="onTypeOfReviewChange()" />
                <span class="gl-radio-custom"></span>
                Only the Post Go-Live stage
              </label>
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">
              Go-Live Date
              <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">The date the system or product goes live</span>
              </span>
            </label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!glFormErrors['GoLiveDate']" (click)="openDatePicker(glDateInput)">
              <span class="gl-date-display">{{ formatDateDisplay(glGoLiveDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #glDateInput class="gl-date-hidden" [(ngModel)]="glGoLiveDate"
                (ngModelChange)="onGoLiveDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (glFormErrors['GoLiveDate']) {
            <span class="field-error gl-field-error">{{ glFormErrors['GoLiveDate'] }}</span>
            }
          </div>

          <div class="form-field"></div>
        </div>

        <!-- Pre & Post row (hidden for post-only) -->
        @if (glTypeOfReview === 'pre-post') {
        <div class="form-row">
          <div class="form-field">
            <label class="field-label">
              GLRR-interim Call Date
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">20 working days prior Go-Live date</span>
              </span>
            </label>
            <input type="text" class="field-input field-input--disabled"
              [value]="formatDateDisplay(glInterimCallDate)" readonly />
          </div>

          <div class="form-field">
            <label class="field-label">
              Pre Go-Live Fieldwork Start Date
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">55 Calendar days prior Go-Live date</span>
              </span>
            </label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!glFormErrors['PreFwStartDate']" (click)="openDatePicker(glPreFwStartInput)">
              <span class="gl-date-display">{{ formatDateDisplay(glPreFwStartDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #glPreFwStartInput class="gl-date-hidden" [(ngModel)]="glPreFwStartDate" (ngModelChange)="onPreFwStartDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (glFormErrors['PreFwStartDate']) {
            <span class="field-error gl-field-error">{{ glFormErrors['PreFwStartDate'] }}</span>
            }
          </div>

          <div class="form-field">
            <label class="field-label">
              Pre Go-Live Fieldwork End Date
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">20 working days prior Go-Live date</span>
              </span>
            </label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!glFormErrors['PreFwEndDate']" (click)="openDatePicker(glPreFwEndInput)">
              <span class="gl-date-display">{{ formatDateDisplay(glPreFwEndDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #glPreFwEndInput class="gl-date-hidden" [(ngModel)]="glPreFwEndDate" (ngModelChange)="onPreFwEndDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (glFormErrors['PreFwEndDate']) {
            <span class="field-error gl-field-error">{{ glFormErrors['PreFwEndDate'] }}</span>
            }
          </div>
        </div>
        }

        <!-- pre-post: Publish Final Report | Post FW Start | Post FW End -->
        @if (glTypeOfReview === 'pre-post') {
        <div class="form-row">
          <div class="form-field">
            <label class="field-label">
              Publish Final Report
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">30 Working Business Days(single Review) 45 Days(Global) From Post-Go-Live End of Field Work (Complete Post-Go-Live Testing)</span>
              </span>
            </label>
            <input type="text" class="field-input field-input--disabled"
              [value]="formatDateDisplay(glPublishFinalReport)" readonly />
          </div>

          <div class="form-field">
            <label class="field-label">
              Post Go-Live Fieldwork Start Date
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">10 Working Business days(WD) post Go-Live date</span>
              </span>
            </label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!glFormErrors['PostFwStartDate']" (click)="openDatePicker(glPostFwStartInput)">
              <span class="gl-date-display">{{ formatDateDisplay(glPostFwStartDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #glPostFwStartInput class="gl-date-hidden" [(ngModel)]="glPostFwStartDate"
                (ngModelChange)="onPostFwStartDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (glFormErrors['PostFwStartDate']) {
            <span class="field-error gl-field-error">{{ glFormErrors['PostFwStartDate'] }}</span>
            }
          </div>

          <div class="form-field">
            <label class="field-label">
              Post Go-Live Fieldwork End Date
              <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">Select the end date for Post Go-Live fieldwork</span>
              </span>
            </label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!glFormErrors['PostFwEndDate']" (click)="openDatePicker(glPostFwEndInput)">
              <span class="gl-date-display">{{ formatDateDisplay(glPostFwEndDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #glPostFwEndInput class="gl-date-hidden" [(ngModel)]="glPostFwEndDate"
                (ngModelChange)="onPostFwEndDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (glFormErrors['PostFwEndDate']) {
            <span class="field-error gl-field-error">{{ glFormErrors['PostFwEndDate'] }}</span>
            }
          </div>
        </div>
        }

        <!-- post-only: Post FW Start | Post FW End | Publish Final Report -->
        @if (glTypeOfReview === 'post-only') {
        <div class="form-row">
          <div class="form-field">
            <label class="field-label">
              Post Go-Live Fieldwork Start Date
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">10 Working Business days(WD) post Go-Live date</span>
              </span>
            </label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!glFormErrors['PostFwStartDate']" (click)="openDatePicker(glPostFwStartInput2)">
              <span class="gl-date-display">{{ formatDateDisplay(glPostFwStartDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #glPostFwStartInput2 class="gl-date-hidden" [(ngModel)]="glPostFwStartDate"
                (ngModelChange)="onPostFwStartDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (glFormErrors['PostFwStartDate']) {
            <span class="field-error gl-field-error">{{ glFormErrors['PostFwStartDate'] }}</span>
            }
          </div>

          <div class="form-field">
            <label class="field-label">
              Post Go-Live Fieldwork End Date
              <span class="required">*</span>
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">Select the end date for Post Go-Live fieldwork</span>
              </span>
            </label>
            <div class="gl-date-wrapper" [class.gl-date-wrapper--error]="!!glFormErrors['PostFwEndDate']" (click)="openDatePicker(glPostFwEndInput2)">
              <span class="gl-date-display">{{ formatDateDisplay(glPostFwEndDate) || 'DD-MMM-YYYY' }}</span>
              <input type="date" #glPostFwEndInput2 class="gl-date-hidden" [(ngModel)]="glPostFwEndDate"
                (ngModelChange)="onPostFwEndDateChange()" />
              <svg class="gl-cal-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            @if (glFormErrors['PostFwEndDate']) {
            <span class="field-error gl-field-error">{{ glFormErrors['PostFwEndDate'] }}</span>
            }
          </div>

          <div class="form-field">
            <label class="field-label">
              Publish Final Report
              <span class="info-tooltip-wrapper">
                <span class="info-icon">i</span>
                <span class="info-tooltip">30 Working Business Days(single Review) 45 Days(Global) From Post-Go-Live End of Field Work (Complete Post-Go-Live Testing)</span>
              </span>
            </label>
            <input type="text" class="field-input field-input--disabled"
              [value]="formatDateDisplay(glPublishFinalReport)" readonly />
          </div>
        </div>
        }
        }

        @if (!useGoLiveLayout) {
        <!-- Row 4 (textarea row — align top) -->
        <div class="form-row form-row--top">

          <!-- Plan Name -->
          <div class="form-field">
            <label class="field-label">Plan Name</label>
            <input type="text" class="field-input" [(ngModel)]="form.PlanName" placeholder="Enter Plan Name" />
          </div>

          <!-- QAD Recommendation -->
          <div class="form-field">
            <label class="field-label">QAD Recommendation (OPP)/QAD Overall Status (Del)</label>
            <textarea class="field-textarea" [(ngModel)]="form.QADRecommendation"
              placeholder="Enter QAD Recommendation (OPP)/QAD Overall Status (Del)"></textarea>
          </div>

          <!-- Client Quality -->
          <div class="form-field">
            <label class="field-label">Client Quality (CQI)</label>
            <div class="select-wrapper">
              <select class="field-select" [(ngModel)]="form.ClientQualityCQI">
                <option value="" disabled>Select CQI</option>
                @for (opt of clientQualityOptions; track opt) {
                <option [value]="opt">{{ opt }}</option>
                }
              </select>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
          </div>

        </div>

        <!-- Row 5 -->
        <div class="form-row">

          <!-- Client Account Lead -->
          <div class="form-field">
            <label class="field-label">Client Account Lead (CR) / POC 1 / MD</label>
            <app-people-picker [(ngModel)]="form.ClientAccountLead" #clientLeadPicker="ngModel"
              placeholder="Search by EID or Name"
              (ngModelChange)="onClientAccountLeadChange($event)"
              (personSelected)="onClientAccountLeadPersonSelected()">
            </app-people-picker>
            @if (clientAccountLeadError && clientLeadPicker.touched) {
              <span class="field-error">{{ clientAccountLeadError }}</span>
            }
          </div>

          <!-- Operation Account Lead -->
          <div class="form-field">
            <label class="field-label">Operation Account Lead - Overall / POC 2</label>
            <app-people-picker [(ngModel)]="form.OperationAccountLead" #operationLeadPicker="ngModel"
              placeholder="Search by EID or Name"
              (ngModelChange)="onOperationAccountLeadChange($event)"
              (personSelected)="onOperationAccountLeadPersonSelected()">
            </app-people-picker>
            @if (operationAccountLeadError && operationLeadPicker.touched) {
              <span class="field-error">{{ operationAccountLeadError }}</span>
            }
          </div>

          <!-- Master Client ID -->
          <div class="form-field">
            <label class="field-label">Master Client ID</label>
            <input type="text" class="field-input" [(ngModel)]="form.MasterClientID"
              (keypress)="onMasterClientIDKeyPress($event)" (input)="onMasterClientIDInput($event)"
              inputmode="numeric" placeholder="Enter Master Client ID" />
            @if (formErrors['MasterClientID']) {
            <span class="field-error">{{ formErrors['MasterClientID'] }}</span>
            }
          </div>

        </div>
        }


      </div><!-- /form-card -->

      <!-- Standard review: location cards section -->
      @if (!useGoLiveLayout) {
      <div class="gl-location-section">
        <div class="gl-location-header-bar">
          <h3 class="gl-location-title">Location to be reviewed</h3>
        </div>
        <div class="gl-location-action-bar">
          <button class="gl-add-location-btn" type="button" (click)="addNewLocationCard()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add New Location
          </button>
        </div>
        <ng-container [ngTemplateOutlet]="cardsListTpl"></ng-container>
      </div>
      }

      <!-- Go-Live / ODR: Location section with Add New Location -->
      @if (useGoLiveLayout) {
      <div class="gl-location-section">
        <!-- Gray header bar — title only -->
        <div class="gl-location-header-bar">
          <h3 class="gl-location-title">Location to be reviewed</h3>
        </div>
        <!-- White action bar — Add New Location button -->
        <div class="gl-location-action-bar">
          <button class="gl-add-location-btn" type="button" (click)="addNewGoLiveCard()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add New Location
          </button>
        </div>

        @if (locationCards.length > 0) {
        <ng-container [ngTemplateOutlet]="cardsListTpl"></ng-container>
        }
      </div><!-- /gl-location-section -->
      }

      <ng-template #cardsListTpl>
      <div class="location-review-cards gl-cards">
        <!-- Location Review Cards -->
        @for (card of locationCards; track $index; let i = $index) {
        <div class="location-card" [class.location-card--parent]="card.IsParentLocation" [class.location-card--readonly]="card.isReadonly">

          @if (useGoLiveLayout) {
          <!-- Go-Live / ODR card top: Delivery Country + Set Parent + delete -->
          <div class="gl-card-top">
            <div class="gl-card-top-grid">
              <!-- Column 1: Delivery Country -->
              <div class="location-field">
                <label class="field-label">Delivery Country <span class="required">*</span></label>
                <div class="searchable-select gl-country-select-{{ i }}" [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                  <div class="searchable-select__display field-select"
                    (click)="isGoLiveCardEditing(i) && toggleGlCardCountryDropdown(i)"
                    [class.placeholder]="!card.LocationCountry">
                    {{ card.LocationCountry || 'Select Country' }}
                  </div>
                  @if (isGoLiveCardEditing(i)) {
                  <span class="select-chevron">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                  }
                  @if (glCountryDropdownKey === i) {
                  <div class="searchable-dropdown" (click)="$event.stopPropagation()">
                    <input type="text" class="searchable-dropdown__search"
                      [(ngModel)]="glCountrySearchTerm" placeholder="Search..." />
                    <ul class="searchable-dropdown__list">
                      @for (c of filteredGlCardCountries(); track c.CountryMasterID) {
                      <li (mousedown)="addGlCardCountry(card, c.CountryName)">{{ c.CountryName }}</li>
                      }
                      @if (filteredGlCardCountries().length === 0) {
                      <li class="no-results">No matches</li>
                      }
                    </ul>
                  </div>
                  }
                </div>
                @if (locationCardErrors[i]?.country) {
                <span class="field-error">{{ locationCardErrors[i].country }}</span>
                }
              </div>
              <!-- Column 2: empty -->
              <div></div>
              <!-- Column 3: Set Parent + edit/save + delete -->
              <div class="gl-card-top-actions">
                <label class="parent-radio">
                  <input type="radio" name="parentLocation" [checked]="card.IsParentLocation"
                    (change)="isGoLiveCardEditing(i) && setParentLocation(i)"
                    [disabled]="!isGoLiveCardEditing(i)" />
                  <span>Set Parent Location</span>
                </label>
                @if (isGoLiveCardEditing(i)) {
                <!-- Save icon -->
                <button class="gl-card-edit-btn" type="button" (click)="saveGoLiveCard(i)" title="Save">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/>
                    <polyline points="17 21 17 13 7 13 7 21"/>
                    <polyline points="7 3 7 8 15 8"/>
                  </svg>
                </button>
                } @else {
                <!-- Edit icon -->
                <button class="gl-card-edit-btn" type="button" (click)="startEditGoLiveCard(i)" title="Edit">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
                  </svg>
                </button>
                }
                @if (locationCards.length > 1) {
                <button class="gl-card-delete-btn" type="button" (click)="removeGoLiveCard(i)"
                  title="Delete location">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"/>
                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                    <path d="M10 11v6"/><path d="M14 11v6"/>
                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                  </svg>
                </button>
                }
              </div>
            </div>
          </div>
          } @else {
          <!-- Standard card top — matches go-live layout -->
          <div class="gl-card-top">
            <div class="gl-card-top-grid">
              <!-- Column 1: Delivery Country -->
              <div class="location-field">
                <label class="field-label">Delivery Country <span class="required">*</span></label>
                <div class="searchable-select card-country-select" [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                  <div class="searchable-select__display field-select"
                    (click)="isGoLiveCardEditing(i) && toggleCardCountryDropdown(i)"
                    [class.placeholder]="!card.LocationCountry">
                    {{ card.LocationCountry || 'Select Country' }}
                  </div>
                  @if (isGoLiveCardEditing(i)) {
                  <span class="select-chevron">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                  }
                  @if (cardCountryDropdownOpenIdx === i) {
                  <div class="searchable-dropdown" (click)="$event.stopPropagation()">
                    <input type="text" class="searchable-dropdown__search" [(ngModel)]="cardCountrySearchTerms[i]"
                      placeholder="Search..." />
                    <ul class="searchable-dropdown__list">
                      @for (country of getFilteredCardCountries(i); track country.CountryMasterID) {
                      <li (mousedown)="onCardCountryChange(i, country.CountryName)">{{ country.CountryName }}</li>
                      }
                      @if (getFilteredCardCountries(i).length === 0) {
                      <li class="no-results">No matches</li>
                      }
                    </ul>
                  </div>
                  }
                </div>
                @if (locationCardErrors[i]?.country) {
                <span class="field-error">{{ locationCardErrors[i].country }}</span>
                }
              </div>
              <!-- Column 2: empty -->
              <div></div>
              <!-- Column 3: Set Parent + save/edit + delete -->
              <div class="gl-card-top-actions">
                <label class="parent-radio">
                  <input type="radio" name="parentLocation" [checked]="card.IsParentLocation"
                    (change)="setParentLocation(i)" />
                  <span>Set Parent Location</span>
                </label>
                @if (isGoLiveCardEditing(i)) {
                <button class="gl-card-edit-btn" type="button" (click)="saveGoLiveCard(i)" title="Save">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/>
                    <polyline points="17 21 17 13 7 13 7 21"/>
                    <polyline points="7 3 7 8 15 8"/>
                  </svg>
                </button>
                } @else {
                <button class="gl-card-edit-btn" type="button" (click)="startEditGoLiveCard(i)" title="Edit">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
                  </svg>
                </button>
                }
                @if (locationCards.length > 1) {
                <button class="gl-card-delete-btn" type="button" (click)="removeLocationCard(i)" title="Delete location">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"/>
                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                    <path d="M10 11v6"/><path d="M14 11v6"/>
                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                  </svg>
                </button>
                }
              </div>
            </div>
          </div>
          }

          <!-- Row 1: Location | Quarter | Month -->
          <div class="location-row">
            <div class="location-field">
              <label class="field-label">Location to be reviewed <span class="required">*</span></label>
              @if (useGoLiveLayout) {
              <div class="searchable-select gl-city-select-{{ i }}"
                [class.field-input--disabled]="!isGoLiveCardEditing(i) || !card.LocationCountry">
                <div class="searchable-select__display field-select"
                  (click)="isGoLiveCardEditing(i) && card.LocationCountry && toggleGlCityDropdown(i)"
                  [class.placeholder]="!card.LocationCity">
                  {{ card.LocationCity || 'Select Location' }}
                </div>
                @if (isGoLiveCardEditing(i)) {
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
                }
                @if (glCityDropdownKey === i) {
                <div class="searchable-dropdown" (click)="$event.stopPropagation()">
                  <input type="text" class="searchable-dropdown__search"
                    [(ngModel)]="glCitySearchTerm" placeholder="Search..." />
                  <ul class="searchable-dropdown__list">
                    @for (city of filteredGlCities(card); track city.CityID) {
                    <li (mousedown)="selectGlCity(card, city.CityName)">{{ city.CityName }}</li>
                    }
                    @if (filteredGlCities(card).length === 0) {
                    <li class="no-results">No matches</li>
                    }
                  </ul>
                </div>
                }
              </div>
              } @else {
              <div class="searchable-select card-city-select"
                [class.field-input--disabled]="!isGoLiveCardEditing(i) || !card.LocationCountry">
                <div class="searchable-select__display field-select"
                  (click)="isGoLiveCardEditing(i) && card.LocationCountry && toggleCardCityDropdown(i)"
                  [class.placeholder]="!card.LocationCity">
                  {{ card.LocationCity || 'Select Location' }}
                </div>
                @if (isGoLiveCardEditing(i)) {
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
                }
                @if (cardCityDropdownOpenIdx === i) {
                <div class="searchable-dropdown" (click)="$event.stopPropagation()">
                  <input type="text" class="searchable-dropdown__search" [(ngModel)]="cardCitySearchTerms[i]"
                    placeholder="Search..." />
                  <ul class="searchable-dropdown__list">
                    @for (city of getFilteredCardCities(i); track city.CityID) {
                    <li (mousedown)="onCardCitySelect(i, city.CityName)">{{ city.CityName }}</li>
                    }
                    @if (getFilteredCardCities(i).length === 0) {
                    <li class="no-results">{{ card.LocationCountry ? 'No matches' : 'Select a country first' }}</li>
                    }
                  </ul>
                </div>
                }
              </div>
              }
              @if (locationCardErrors[i]?.city) {
              <span class="field-error">{{ locationCardErrors[i].city }}</span>
              }
              @if (locationCardErrors[i]?.duplicate) {
              <span class="field-error">{{ locationCardErrors[i].duplicate }}</span>
              }
            </div>
            <div class="location-field">
              <label class="field-label">Quarter</label>
              <div class="select-wrapper">
                <select class="field-select" [(ngModel)]="card.Quarter"
                   [disabled]="!isGoLiveCardEditing(i)"
                  [class.field-input--disabled]="!isGoLiveCardEditing(i)"
                  (ngModelChange)="onQuarterChange(card)">
                  <option value="" disabled>Select Quarter</option>
                  @for (q of quarterOptions; track q) {
                  <option [value]="q">{{ q }}</option>
                  }
                </select>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
            </div>
            <div class="location-field">
              <label class="field-label">Proposed Month</label>
              <div class="select-wrapper">
                <select class="field-select" [(ngModel)]="card.ProposedMonth"
                  [disabled]="!isGoLiveCardEditing(i) || !card.Quarter"
                  [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                  <option value="" disabled>Select Proposed Month</option>
                  @for (m of getMonthsForQuarter(card.Quarter); track m) {
                  <option [value]="m">{{ m }}</option>
                  }
                </select>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <!-- Row 2: R&C Manager | R&C Supervisor | R&C Reviewer -->
          <div class="location-row">
            <div class="location-field">
              <label class="field-label">R&amp;C Manager <span class="required">*</span></label>
              <div class="searchable-select manager-select"
                [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                <div class="searchable-select__display field-select"
                  (click)="isGoLiveCardEditing(i) && toggleManagerDropdown('rc-mgr-' + i)"
                  [class.placeholder]="!card.RCManager">
                  {{ managerLabel(card.RCManager) || 'Search by EID or Name' }}
                </div>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </span>
                @if (managerDropdownKey === 'rc-mgr-' + i) {
                <div class="searchable-dropdown">
                  <input type="text" class="searchable-dropdown__search" [(ngModel)]="managerSearchTerm" placeholder="Search..." />
                  <ul class="searchable-dropdown__list">
                    @for (mgr of filteredManagers; track mgr.value) {
                    <li (mousedown)="selectManager(card, 'RCManager', mgr.value, i)">{{ mgr.label }}</li>
                    }
                    @if (filteredManagers.length === 0) {
                    <li class="no-results">No matches</li>
                    }
                  </ul>
                </div>
                }
              </div>
              @if (locationCardErrors[i]?.rcManager) {
              <span class="field-error">{{ locationCardErrors[i].rcManager }}</span>
              }
            </div>
            <div class="location-field">
              <label class="field-label">R&amp;C Supervisor <span class="required">*</span></label>
              <div class="searchable-select supervisor-select"
                [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                <div class="searchable-select__display field-select"
                  (click)="isGoLiveCardEditing(i) && toggleSupervisorDropdown('rc-' + i)"
                  [class.placeholder]="!card.RCSupervisor">
                  {{ supervisorLabel(card.RCSupervisor) || 'Search by EID or Name' }}
                </div>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </span>
                @if (supervisorDropdownKey === 'rc-' + i) {
                <div class="searchable-dropdown">
                  <input type="text" class="searchable-dropdown__search" [(ngModel)]="supervisorSearchTerm"
                    placeholder="Search..." />
                  <ul class="searchable-dropdown__list">
                    @for (sup of filteredSupervisors; track sup.value) {
                    <li (mousedown)="selectSupervisor(card, 'RCSupervisor', sup.value, i)">{{ sup.label }}</li>
                    }
                    @if (filteredSupervisors.length === 0) {
                    <li class="no-results">No matches</li>
                    }
                  </ul>
                </div>
                }
              </div>
              @if (locationCardErrors[i]?.rcSupervisor) {
              <span class="field-error">{{ locationCardErrors[i].rcSupervisor }}</span>
              }
            </div>
            <div class="location-field">
              <label class="field-label">R&amp;C Reviewer  <span class="required">*</span> </label>
              <div class="searchable-select reviewer-select"
                [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                <div class="searchable-select__display field-select"
                  (click)="isGoLiveCardEditing(i) && toggleReviewerDropdown('rc-rev-' + i)"
                  [class.placeholder]="!card.RCReviewer">
                  {{ reviewerLabel(card.RCReviewer) || 'Search by EID or Name' }}
                </div>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </span>
                @if (reviewerDropdownKey === 'rc-rev-' + i) {
                <div class="searchable-dropdown">
                  <input type="text" class="searchable-dropdown__search" [(ngModel)]="reviewerSearchTerm" placeholder="Search..." />
                  <ul class="searchable-dropdown__list">
                    @for (rev of filteredReviewers; track rev.value) {
                    <li (mousedown)="selectReviewer(card, 'RCReviewer', rev.value, i)">{{ rev.label }}</li>
                    }
                    @if (filteredReviewers.length === 0) {
                    <li class="no-results">No matches</li>
                    }
                  </ul>
                </div>
                }
              </div>
              @if (locationCardErrors[i]?.rcReviewer) {
              <span class="field-error">{{ locationCardErrors[i].rcReviewer }}</span>
              }
            </div>
          </div>

          <!-- Row 3: Secondary roles -->
          <div class="location-row">
            <div class="location-field">
              <label class="field-label">Secondary R&amp;C Manager</label>
              <div class="searchable-select manager-select"
                [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                <div class="searchable-select__display field-select"
                  (click)="isGoLiveCardEditing(i) && toggleManagerDropdown('sec-mgr-' + i)"
                  [class.placeholder]="!card.SecondaryManager">
                  {{ managerLabel(card.SecondaryManager) || 'Search by EID or Name' }}
                </div>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </span>
                @if (managerDropdownKey === 'sec-mgr-' + i) {
                <div class="searchable-dropdown">
                  <input type="text" class="searchable-dropdown__search" [(ngModel)]="managerSearchTerm" placeholder="Search..." />
                  <ul class="searchable-dropdown__list">
                    @for (mgr of filteredManagers; track mgr.value) {
                    <li (mousedown)="selectManager(card, 'SecondaryManager', mgr.value, i)">{{ mgr.label }}</li>
                    }
                    @if (filteredManagers.length === 0) {
                    <li class="no-results">No matches</li>
                    }
                  </ul>
                </div>
                }
              </div>
              @if (locationCardErrors[i]?.manager) {
              <span class="field-error">{{ locationCardErrors[i].manager }}</span>
              }
            </div>
            <div class="location-field">
              <label class="field-label">Secondary R&amp;C Supervisor</label>
              <div class="searchable-select supervisor-select"
                [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                <div class="searchable-select__display field-select"
                  (click)="isGoLiveCardEditing(i) && toggleSupervisorDropdown('sec-' + i)"
                  [class.placeholder]="!card.SecondarySupervisor">
                  {{ supervisorLabel(card.SecondarySupervisor) || 'Search by EID or Name' }}
                </div>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </span>
                @if (supervisorDropdownKey === 'sec-' + i) {
                <div class="searchable-dropdown">
                  <input type="text" class="searchable-dropdown__search" [(ngModel)]="supervisorSearchTerm"
                    placeholder="Search..." />
                  <ul class="searchable-dropdown__list">
                    @for (sup of filteredSupervisors; track sup.value) {
                    <li (mousedown)="selectSupervisor(card, 'SecondarySupervisor', sup.value, i)">{{ sup.label }}</li>
                    }
                    @if (filteredSupervisors.length === 0) {
                    <li class="no-results">No matches</li>
                    }
                  </ul>
                </div>
                }
              </div>
              @if (locationCardErrors[i]?.supervisor) {
              <span class="field-error">{{ locationCardErrors[i].supervisor }}</span>
              }
            </div>
            <div class="location-field">
              <label class="field-label">Secondary R&amp;C Reviewer</label>
              <div class="searchable-select reviewer-select"
                [class.field-input--disabled]="!isGoLiveCardEditing(i)">
                <div class="searchable-select__display field-select"
                  (click)="isGoLiveCardEditing(i) && toggleReviewerDropdown('sec-rev-' + i)"
                  [class.placeholder]="!card.SecondaryReviewer">
                  {{ reviewerLabel(card.SecondaryReviewer) || 'Search by EID or Name' }}
                </div>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </span>
                @if (reviewerDropdownKey === 'sec-rev-' + i) {
                <div class="searchable-dropdown">
                  <input type="text" class="searchable-dropdown__search" [(ngModel)]="reviewerSearchTerm" placeholder="Search..." />
                  <ul class="searchable-dropdown__list">
                    @for (rev of filteredReviewers; track rev.value) {
                    <li (mousedown)="selectReviewer(card, 'SecondaryReviewer', rev.value, i)">{{ rev.label }}</li>
                    }
                    @if (filteredReviewers.length === 0) {
                    <li class="no-results">No matches</li>
                    }
                  </ul>
                </div>
                }
              </div>
              @if (locationCardErrors[i]?.reviewer) {
              <span class="field-error">{{ locationCardErrors[i].reviewer }}</span>
              }
            </div>
          </div>

        </div>
        }
      </div>
      </ng-template>

      <!-- Comments & Attachment Section -->
      <div class="comments-attachment-card">
        <div class="comments-attachment-row">
          <!-- Comments -->
          <div class="comments-field">
            <label class="field-label">Comments</label>
            <textarea class="field-textarea comments-textarea" [(ngModel)]="form.Comments"
              placeholder="Comments"></textarea>
          </div>
          <!-- Attachment -->
          <div class="attachment-field">
            <label class="field-label">{{ isOnDemand || isSpecialProject ? 'Agreement Document' : 'Attachment' }}</label>
            <div class="attach-link" (click)="fileInput.click()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
                  stroke="#A100FF" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
                  transform="rotate(-45 12 12)" />
              </svg>
              <span>Attach Document</span>
            </div>
            <input #fileInput type="file" multiple hidden (change)="onFilesSelected($event)"
              accept=".pdf,.msg,.xls,.xlsx,.doc,.docx,.txt,.ppt,.pptx,.jpg,.jpeg,.png,.zip" />
            @if (attachedFiles.length > 0) {

            @for (file of attachedFiles; track file.name; let i = $index) {
            <div class="file-selected">Selected file: <strong>{{ file.name }}</strong>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <i class="fa fa-trash delete-icon" (click)="removeAttachedFile(i)" title="Remove file"></i>
            </div>

            }

            }
            @if (attachmentErrors.length > 0) {
            @for (error of attachmentErrors; track error) {
            <span class="field-error attachment-error">{{ error }}</span>
            }
            }
            <span class="attachment-hint">
              Supported file types: PDF, Outlook Mail (.msg), Excel (.xls, .xlsx), Word (.doc, .docx),
              Text (.txt), PowerPoint (.ppt, .pptx), Image (.jpg, .jpeg, .png), ZIP (.zip).
              Max file size: 20 MB each.
            </span>
          </div>
        </div>
      </div>

      <!-- Info Banner -->
      <div class="info-banner">
        <span class="info-banner-icon">
          <svg width="24" height="20" viewBox="0 0 24 24">
            <path d="M4 2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8l-4 4V4a2 2 0 0 1 2-2z" fill="#1a1a1a" />
            <rect x="11" y="6" width="2" height="8" rx="1" fill="#fff" />
            <rect x="11" y="16" width="2" height="2" rx="1" fill="#fff" />
          </svg>
        </span>
        <div class="info-banner-text">
          If the mandatory information is not available in the form, follow the steps below depending on the field:
          <ol class="info-banner-list">
            <li><strong>Fields with a tooltip or guideline</strong> (e.g. Master Client, D&amp;T Project Name, Contract
              Number, Market, Market Unit): follow the instructions in the field's tooltip or guideline.</li>
            <li><strong>R&amp;C users not available in AST</strong>: raise a request through the
              <a class="info-banner-link" [routerLink]="['/request']" [queryParams]="{ new: 1 }"
                target="_blank" rel="noopener"><strong>[Request]</strong></a> module.</li>
            <li><strong>Other fields</strong> (e.g. Proposed Year, Delivery Country, Locations to be Reviewed): contact
              the R&amp;C Admins.</li>
          </ol>
          Meanwhile, you can use <strong>'Save as Draft'</strong> to save your form and complete it later.
        </div>
      </div>

      <!-- Draft Saved Notification -->
      @if (draftSavedMessage) {
      <div class="draft-saved-toast">Draft saved successfully!</div>
      }

      <!-- Action Buttons -->
      <div class="action-buttons">
        <a class="action-reset" [class.action-reset--disabled]="!isFormDirty" (click)="isFormDirty && resetForm()">Reset
          Value</a>
        <button class="action-cancel" [disabled]="!isFormDirty" (click)="cancelForm()">Cancel</button>
        <button class="action-draft" [disabled]="!isFormDirty" (click)="saveAsDraft()">Save as Draft</button>
        <button class="action-submit" [disabled]="!isFormDirty" (click)="submitForm()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
          </svg>
          Submit
        </button>
      </div>
    </div>
  </main>


  <!-- Error Popup -->
  @if (showErrorPopup) {
  <div class="error-popup-overlay" (click)="closeErrorPopup()">
    <div class="error-popup" (click)="$event.stopPropagation()">
      <div class="error-popup-header">
        <span class="error-popup-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="#dc2626" />
            <rect x="11" y="6" width="2" height="8" rx="1" fill="#fff" />
            <rect x="11" y="16" width="2" height="2" rx="1" fill="#fff" />
          </svg>
        </span>
        <h2 class="error-popup-title">Unable to Save</h2>
        <button class="error-popup-close" (click)="closeErrorPopup()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="12" r="11" fill="#333" />
            <path d="M8 8l8 8M16 8l-8 8" stroke="#fff" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="error-popup-body">
        @for (message of errorPopupMessages; track message) {
        <p class="error-popup-message">{{ message }}</p>
        }
      </div>
      <div class="error-popup-footer">
        <button class="error-popup-ok" (click)="closeErrorPopup()">OK</button>
      </div>
    </div>
  </div>
  }

  <!-- Cancel Confirmation Popup -->
  @if (showCancelConfirm) {
  <div class="error-popup-overlay" (click)="dismissCancelConfirm()">
    <div class="error-popup cancel-confirm-popup" (click)="$event.stopPropagation()">
      <div class="error-popup-header">
        <span class="error-popup-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="#f59e0b" />
            <rect x="11" y="6" width="2" height="8" rx="1" fill="#fff" />
            <rect x="11" y="16" width="2" height="2" rx="1" fill="#fff" />
          </svg>
        </span>
        <h2 class="error-popup-title">Cancel Review</h2>
        <button class="error-popup-close" (click)="dismissCancelConfirm()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="12" r="11" fill="#333" />
            <path d="M8 8l8 8M16 8l-8 8" stroke="#fff" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="error-popup-body">
        <p class="error-popup-message">Are you sure you want to cancel? All entered data will be lost and no record will be saved.</p>
      </div>
      <div class="error-popup-footer cancel-confirm-footer">
        <button class="error-popup-ok cancel-confirm-no" (click)="dismissCancelConfirm()">No</button>
        <button class="error-popup-ok cancel-confirm-yes" (click)="confirmCancel()">Yes</button>
      </div>
    </div>
  </div>
  }
</div>
